import React from 'react';
import { func } from 'prop-types';
import { useFormatMessage } from 'react-intl-hooks';

import BlankState from '@/components/BlankState';

import styles from '../../../../../../Event/scenes/Recruiter/scenes/Jobdating/container/ParticipantsView/styles.less';

const NoJobdating = ({ goTo }) => {
  const t = useFormatMessage();
  
  const DATA = {
    title: t({ id: 'event.list.blankState.title' }),
    content: t({ id: 'event.list.blankState.content' }),
    goto: '/events/archive',
  };
  return (
    <BlankState
      className={styles.blankState}
      style={{ marginTop: '80px' }}
      title={DATA.title}
      content={<a role="button" tabIndex={0} onClick={() => goTo(DATA.goto)}>{DATA.content}</a>}
      icon="blank-state-cactus"
    />
  );
};
NoJobdating.propTypes = {
  goTo: func,
};
export default NoJobdating;

